"use client";

import React from "react";
import Slider from "react-slick";
import clsx from "clsx";
import { useState, useRef } from "react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export function AutoScrollSlider({
  children,
  num,
}: {
  children: React.ReactNode;
  num: number | string;
}) {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: Number(num),
    slidesToScroll: 1,
    autoplay: true,
    speed: 8000,
    autoplaySpeed: 1000,
    cssEase: "linear",
    arrows: false,
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>{children}</Slider>
    </div>
  );
}

export function AutoPlaySlider({
  children,
  texts,
}: {
  children: React.ReactNode;
  texts: string[];
}) {
  const [current, setCurrent] = useState(0);
  const sliderRef = useRef<Slider>(null);

  const handleClick = (n: number) => {
    setCurrent(n);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(n);
    }
  };

  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    // slidesToScroll: 1,
    autoplay: true,
    // speed: 2000,
    // autoplaySpeed: 1000,
    cssEase: "linear",
    arrows: false,

    afterChange: (n: number) => {
      setCurrent(n);
    },
    appendDots: (dots: any) => (
      <div
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          color: "#fff",
          bottom: 0,
        }}
      >
        {/* <div>{text}</div> */}
        <div className="mx-[15px] text-[14px] mt-[3px] w-[0] grow z-20 text-left whitespace-nowrap overflow-hidden text-ellipsis">
          {texts[current]}
        </div>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i: number) => (
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          marginLeft: "10px",
          cursor: "pointer",
          backgroundColor: "white",
        }}
      >
        <div
          onClick={() => handleClick(i)}
          key={i + 1}
          className={clsx(
            "w-[12px] h-[12px] rounded-full mr-[10px] mt-[5px] cursor-pointer",
            {
              "bg-[red]": current == i,
              "bg-white": current != i,
            }
          )}
        ></div>
      </div>
    ),
  };
  return (
    <div className="slider-container">
      <Slider ref={sliderRef} {...settings}>
        {children}
      </Slider>
    </div>
  );
}
